<div class="row container-style mb-1" [hidden]="!isFormView">
  <div class="col-12 col-md-12 py-1">
    <form novalidate [formGroup]="formRepair">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
          <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'" [list]="listArticle"
            [required]="true" (onChangeSelect)="getArticle($event)"></app-custom-autocomplete>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
          <app-custom-textarea formControlName="detailText" [labelText]="'Detalle'" [rows]="1"></app-custom-textarea>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-text [labelText]="'Und'" [value]="unit" [disabled]="true"></app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'" [required]="true"
            (onChangeNumber)="calculateValues()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="unitValue" [labelText]="'Vr.Unit.'" [required]="true"
            (onChangeNumber)="calculateValues()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal [labelText]="'Vr. Total'" [value]="totalValue"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-2 col-md-5 col-sm-6 col-12 d-flex mt-2">
          <div class="d-flex align-items-end justify-content-end gap-1 container-buttons bottom-0">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined" [disabled]="disabledDetail"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="row container-style">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end gap-2 py-1">
    <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'6rem'" [severity]="'success'"
      [disabled]="disabledDetail" [variant]="undefined" (onClick)="newRepair(true)"></app-custom-button>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
    <app-custom-table [headers]="header" [data]="detailData" [actions]="tableActions" [showCheckbox]="!disabledDetail"
      [checkBoxAction]="checkboxActions" [clearSelectionTrigger]="clearSelectionTrigger"
      (onPageChange)="onPageChange($event)" (onRecoverData)="getAllRepairsWithPagination()"
      (onAction)="onAction($event)"></app-custom-table>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end my-1">
    <app-custom-button [title]="'Salir'" [label]="'Salir'" [severity]="'danger'"
      (onClick)="close()"></app-custom-button>
  </div>
</div>